module.exports = __webpack_public_path__ + "img/dropsLive_1248.e7fee4f0.png";